import { render } from "./Marketing.vue?vue&type=template&id=416ed02e"
import script from "./Marketing.vue?vue&type=script&lang=js"
export * from "./Marketing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__